export const SET_LANGUAGE = 'app/SET_LANGUAGE';
export const SET_LOCATION = 'app/SET_LOCATION';
export const SET_ANSWERS = 'app/SET_ANSWERS';
export const SET_UUID = 'app/SET_UUID';
export const SET_SCREENING_DATA = 'app/SET_SCREENING_DATA';
export const SET_APP_DATA = 'app/SET_APP_DATA';
export const SET_EMPLOYEE_STATUS = 'app/SET_EMPLOYEE_STATUS';
export const SET_COUGH_TEST_RESULT = 'app/SET_COUGH_TEST_RESULT';
